export const GET_ALL_ANNOUNCED_REWARDS = 'GET_ALL_ANNOUNCED_REWARDS'
export const GET_ALL_UPCOMMING_REWARDS = 'GET_ALL_UPCOMMING_REWARDS'